export * from './locales.js'
export { getFromTransifex } from './transifex.js'
